import { IUserAccountStore } from '../../index'
import { ISendNotificationErrorMMessage } from '../../../../actions/notification/sendError'

export default function(
  store: IUserAccountStore,
  action: ISendNotificationErrorMMessage,
): IUserAccountStore {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      items: store.notifications.items.map(not =>
        String(not.id) === String(action.notificationId)
          ? { ...not, sending: 1 }
          : not,
      ),
    },
  }
}
